import React, { useState } from "react";

export default function CreateOrganization() {
  const [orgName, setOrgName] = useState("");
  const [adminEmail, setAdminEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const validateOrgName = (name) => /^[A-Za-z0-9_]+$/.test(name);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    if (!validateOrgName(orgName)) {
      setError("Organization name can only contain letters, numbers, and underscores.");
      return;
    }

    if (!adminEmail.includes("@")) {
      setError("Please enter a valid email address.");
      return;
    }

    setLoading(true);

    try {
      const idToken = localStorage.getItem("idToken");

      const res = await fetch(
        `/api/super-admin/admin/invite-organization`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`
          },

          body: JSON.stringify({
            org_admin_email: adminEmail,
            org_name_suggested: orgName
          })
        }
      );

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Failed to send invitation.");
      }

      setSuccess("Invitation sent successfully!");
      setOrgName("");
      setAdminEmail("");
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  return (
    <div>
      <h1>Create New Organization</h1>
      <p>Enter the organization name and admin email to begin onboarding.</p>

      <form
        onSubmit={handleSubmit}
        style={{
          marginTop: "20px",
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          background: "#f8fafc",
          maxWidth: "500px"
        }}
      >
        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "6px" }}>
            Organization Name
          </label>
          <input
            type="text"
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            placeholder="acme_biotech"
            style={{
              width: "90%",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label style={{ display: "block", marginBottom: "6px" }}>
            Organization Admin Email<br/>(This must be already registered email address of your organization's admin user on CloudGenomics)
          </label>
          <input
            type="email"
            value={adminEmail}
            onChange={(e) => setAdminEmail(e.target.value)}
            placeholder="admin@example.com"
            style={{
              width: "90%",
              padding: "10px",
              borderRadius: "4px",
              border: "1px solid #ccc"
            }}
          />
        </div>

        {error && (
          <div style={{ color: "red", marginBottom: "12px" }}>{error}</div>
        )}

        {success && (
          <div style={{ color: "green", marginBottom: "12px" }}>{success}</div>
        )}

        <button
          type="submit"
          disabled={loading}
          style={{
            padding: "10px 16px",
            background: "#2563eb",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
        >
          {loading ? "Sending..." : "Send Invitation"}
        </button>
      </form>
    </div>
  );
}
